import axiosInstance from '../axiosInterceptor/axiosInstance'

// LiveKit join info for the current operator to commentate a game.
// 409 (no live stream yet) and 404 (not an assigned operator) are expected
// states the page handles inline, so suppress the global error toast.
const getStudioJoinInfo = async (orgId, gameId) =>
  (
    await axiosInstance.get(`v1/orgs/${orgId}/studio/games/${gameId}/join-info`, {
      skipErrorNotification: true,
    })
  )?.data

export default getStudioJoinInfo
